import {
  BaseQueryFn,
  EndpointBuilder,
  QueryDefinition,
} from '@reduxjs/toolkit/query';

import type { ISignatureEnvelopeSignage } from 'interfaces/SignatureEnvelopeSignage.interface';
import type { IGetSignatureEnvelopeSignageItemArgs } from './signatureEnvelopeSignages.api.types';

export const getSignatureEnvelopeSignageItem = (
  build: EndpointBuilder<BaseQueryFn, string, string>
): QueryDefinition<
  IGetSignatureEnvelopeSignageItemArgs,
  BaseQueryFn,
  string,
  ISignatureEnvelopeSignage
> =>
  build.query<ISignatureEnvelopeSignage, IGetSignatureEnvelopeSignageItemArgs>({
    providesTags: ['SignatureEnvelopeSignage'],
    query: (queryArg: IGetSignatureEnvelopeSignageItemArgs) => ({
      url: `api/signature_envelope_signages/${queryArg.id}`,
    }),
  });
